/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Badge_FailedInputs */

const vi_einvoice_badge_failed = /** @type {(inputs: Einvoice_Badge_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi MISA chưa thành công`)
};

/**

* @param {Einvoice_Badge_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_badge_failed = /** @type {((inputs?: Einvoice_Badge_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Badge_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_badge_failed(inputs)
});